const getAuth0ClientId = () => {
  let clientId = '';
  if (window.location.origin.includes('app.zebel.io')) clientId = 'mDfPhaTYMI3kIBOYQo3NZoU8HinI5z3S';
  if (window.location.origin.includes('amazon.zebel.io')) clientId = 'joSYCRkVvo3GaLOm0JxQKscpGj8g3nyr';
  if (window.location.origin.includes('local')) clientId = '7wgmvCRWSlGLAHG06VE12M8ijN9JoIlV';

  return clientId;
};

const getAuth0RedirectUri = () => {
  return window.location.origin;
};

const getAuth0Audience = () => {
  let aud = '';
  if (window.location.origin.includes('app.zebel.io')) aud = 'https://api.zebel.io';
  if (window.location.origin.includes('amazon.zebel.io')) aud = 'https://api.dev.zebel.io';
  if (window.location.origin.includes('local')) aud = 'https://app.eng.zebel.local:5000';
  return aud;
};

const getAuth0Domain = () => {
  let domain = '';
  if (window.location.origin.includes('app.zebel.io')) domain = 'auth.zebel.io';
  if (window.location.origin.includes('amazon.zebel.io')) domain = 'zebel-dev.us.auth0.com';
  if (window.location.origin.includes('local')) domain = 'zebel-dev.us.auth0.com';
  return domain;
};

export { getAuth0ClientId, getAuth0RedirectUri, getAuth0Audience, getAuth0Domain };
